import { Spinner } from "@alpacahq/ui/old";

import { Page } from "~/v2/components";

export const MarketDataLoadingPres = () => (
  <Page
    title="Market Data Subscription"
    className="p-8 pt-0 xs:pl-0 md:p-8 md:pt-0 md:pl-0"
  >
    <div className="flex justify-center pt-32">
      <Spinner />
    </div>
  </Page>
);
